import { Stack, styled, TableBody, Typography } from "@mui/material"
import { COLORS } from "../../../../utils"

export const StyledListLabel = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: 1.5,
  color: COLORS.LABEL_GREY
})

export const StyledItemSubtitle = styled(Typography)({
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: 1.33,
    color: COLORS.BLACK800
})

export const StyledListValue = styled(Typography)({
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 1.5,
    color: COLORS.BLACK_900
})

const cardStyles = {
    backgroundColor: COLORS.BLACK_50,
    borderRadius: "8px",
    padding: "16px",
}

export const StyledCardContent = styled(Stack)(cardStyles)

export const StyledTableBody = styled(TableBody)(cardStyles)
